<script lang="ts">
	import type { Image } from '$models/Image/Image';
	import type { Layout } from '$models/Layout/Layout';
	import type { Link } from '$models/Link/Link';

	interface Props {
		layout: Layout;
		links: Link[];
	}

	const { layout }: Props = $props();

	// Component properties
	const links = $derived(layout.footerLinks);
	const paymentLogos: Image[] = $derived(layout.paymentLogos);
	const trustLogos: Image[] = $derived(layout.trustLogos);
	const bCorpLogo: Image | null = $derived(layout.footerBcorpLogo);

	// Prepare the dynamic copyright text
	const footerCopyrightText = $derived(
		layout.footerCopyrightText.replaceAll('%year%', new Date().getFullYear().toString())
	);
</script>

{#if (paymentLogos && paymentLogos.length > 0) || (trustLogos && trustLogos.length > 0)}
	<div class="bottom-bar">
		<div class="bottom-bar-container container">
			{#if bCorpLogo}
				<div class="bottom-bar-certification">
					<img
						src={bCorpLogo.url}
						alt={bCorpLogo.alt}
						width={bCorpLogo.width}
						height={bCorpLogo.height}
						loading="lazy"
						decoding="async"
					/>
				</div>
			{/if}
			<div class="bottom-bar-menu">
				{#if links}
					<div class="bottom-bar-menu-links">
						{#each links as link}
							<a href={link.url} target={link.target}>{link.title}</a>
						{/each}
					</div>
				{/if}
				<div class="bottom-bar-copyright">
					{footerCopyrightText}
				</div>
			</div>
			<div class="bottom-bar-icons">
				{#if paymentLogos}
					{#each paymentLogos as logo}
						<div class="bottom-bar-icon">
							<img
								src={logo.url}
								alt={logo.alt}
								width={logo.width}
								height={logo.height}
								loading="lazy"
								decoding="async"
							/>
						</div>
					{/each}
				{/if}
				{#if trustLogos}
					{#each trustLogos as logo}
						<div class="bottom-bar-icon">
							<img
								src={logo.url}
								alt={logo.alt}
								width={logo.width}
								height={logo.height}
								loading="lazy"
								decoding="async"
							/>
						</div>
					{/each}
				{/if}
			</div>
		</div>
	</div>
{/if}

<style lang="postcss">
	.bottom-bar {
		& {
			position: relative;
			z-index: 1;
			padding-block: 16px;
			background-color: var(--color-primary-light);
		}

		&-container {
			display: flex;
			flex-direction: column;
			gap: 24px;
			padding-inline: 32px;
		}

		&-certification {
			img {
				display: block;
				width: auto;
				max-height: 80px;
				padding: 6px;
			}
		}

		&-menu {
			order: 1;

			&,
			&-links {
				display: flex;
				flex-direction: column;
				gap: 24px;
				font-size: 14px;
			}

			a:hover {
				text-decoration: underline;
			}
		}

		&-icons {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 16px 10px;
		}

		&-icon {
			img {
				display: block;
				width: 100%;
				height: 100%;
				max-width: 50px;
				max-height: 28px;
				object-fit: contain;
			}
		}

		@media (--xl) {
			&-container {
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				justify-content: space-between;
				gap: 0;
				padding-inline: 16px;
			}

			&-menu {
				order: 0;

				&,
				&-links {
					flex-direction: row;
					gap: 40px;
				}
			}

			&-icons {
			}

			&-icon img {
				max-height: 22px;
			}
		}
	}
</style>
